"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

var DynamyndAnalyticsData =
/** @class */
function () {
  function DynamyndAnalyticsData(config) {
    this.sessionId = config.sessionId;
    this.action = config.action;
    this.actionType = config.actionType;
    this.actionOn = config.actionOn;
    this.personId = config.personId;
    this.data = this.setData(config.data);
  }

  DynamyndAnalyticsData.prototype.setData = function (data) {
    return __assign(__assign({}, data), {
      timestamp: moment_1.default().utc()
    });
  };

  return DynamyndAnalyticsData;
}();

exports.DynamyndAnalyticsData = DynamyndAnalyticsData;